import type { MessageResult } from '../type/message-result';
import type { ToastMessageOptions } from '../type/message-options';
import type { Observable } from 'rxjs';
import { MessageService } from './message.service';
import type { StrictOmit } from '@pct-ts/typing';

export type OpenToastOptionsParameter = StrictOmit<ToastMessageOptions, 'type'>;
export type OpenSuccessToastOptionsParameter = StrictOmit<OpenToastOptionsParameter, 'messageType'>;
export type OpenInfoToastOptionsParameter = OpenSuccessToastOptionsParameter;
export type OpenWarningToastOptionsParameter = OpenSuccessToastOptionsParameter;
export type OpenErrorToastOptionsParameter = OpenSuccessToastOptionsParameter;

export function openToast(
  options: OpenToastOptionsParameter,
): Observable<MessageResult | undefined> {
  return MessageService.INSTANCE.open({ ...options, type: 'TOAST' });
}

export function openSuccessToast(
  options: OpenSuccessToastOptionsParameter,
): Observable<MessageResult | undefined> {
  return openToast({ ...options, messageType: 'SUCCESS' });
}

export function openInfoToast(
  options: OpenInfoToastOptionsParameter,
): Observable<MessageResult | undefined> {
  return openToast({ ...options, messageType: 'INFO' });
}

export function openWarningToast(
  options: OpenWarningToastOptionsParameter,
): Observable<MessageResult | undefined> {
  return openToast({ ...options, messageType: 'WARNING' });
}

export function openErrorToast(
  options: OpenErrorToastOptionsParameter,
): Observable<MessageResult | undefined> {
  return openToast({ ...options, messageType: 'ERROR' });
}
